import axios from 'axios';

export const CheckQueueNumberApi = {
  getQueueInfo: (iin) => axios.get(
    `/api/public/info/kindergarten_queue_by_iin/${iin}`
  ),
  getQueueVoucherInfo: (iin) => axios.get(
    `/api/public/info/kindergarten_voucher_queue_by_iin/${iin}`
  ),
};
